import { createFileRoute } from '@tanstack/react-router';
import { ReceiveLoadWizard } from '../../../features/purchasing-intake/ReceiveLoadWizard';

/** Owned by G20. Default tab of the purchasing-intake screen group — "Receive a
 * load" (BUILD_SPEC.md §8.1), matching HOME_TASKS's task button which routes
 * straight to `/purchasing-intake`. */
export const Route = createFileRoute('/_authenticated/purchasing-intake/')({
  component: ReceiveLoadWizard,
});
